import api from "@/plugins/api";
/** One page is enough: the picker searches server-side above this size. */
export const NOTIFICATION_USERS_PAGE_SIZE = 100;
export async function getNotificationRoles() {
    const response = await api.get("/roles/all", {
        unwrapEnvelope: true,
    });
    return response.data.map((role) => ({ type: role.value, label: role.label }));
}
export async function searchNotificationUsers(search) {
    const params = {
        pageNumber: 1,
        pageSize: NOTIFICATION_USERS_PAGE_SIZE,
        sortBy: "Name",
        sortDirection: "Ascending",
    };
    if (search)
        params.search = search;
    const response = await api.get("/users", { unwrapEnvelope: true, params });
    return (response.data?.userList?.items ?? []).map((item) => ({
        id: String(item.id ?? ""),
        name: String(item.name ?? ""),
        email: String(item.email ?? ""),
    }));
}
export async function getNotificationUser(userId) {
    const response = await api.get(`/users/${userId}/details`, {
        unwrapEnvelope: true,
    });
    const data = response.data ?? {};
    const name = [data.first_name, data.last_name].filter(Boolean).join(" ");
    return { id: String(data.id ?? userId), name, email: String(data.email ?? "") };
}
